import { jsx as _jsx } from "react/jsx-runtime";
import { RoutePointOrder } from "@/components/RouteForm2/createRoutePointsTransferOptions";
export class OrderToRoutePointTransferData {
    adapt(source) {
        const data = {
            idOrder: source.id,
            addressInfo: source.addressInfo,
            orderIndex: 0,
            idRoute: null, // Will be set when route is created
            idBase: null,
            plannedArrivalTime: null,
            plannedDepartureTime: null,
            actualArrivalTime: null,
            actualDepartureTime: null,
            expectedArrivalTime: null,
            expectedDepartureTime: null,
        };
        return {
            key: source.id,
            label: source.addressInfo.getAddress() || "Адрес не указан",
            data,
            renderLabel: () => _jsx(RoutePointOrder, { point: data, order: source }),
        };
    }
    adaptMany(sources) {
        return sources.map((source) => this.adapt(source));
    }
}
export class OrderToRoutePointCreateData {
    adapt(source) {
        const data = {
            idOrder: source.id,
            addressInfo: source.addressInfo,
            orderIndex: 0,
            idRoute: null, // Will be set when route is created
            idBase: null,
            plannedArrivalTime: null,
            plannedDepartureTime: null,
            actualArrivalTime: null,
            actualDepartureTime: null,
            expectedArrivalTime: null,
            expectedDepartureTime: null,
        };
        return data;
    }
    adaptMany(sources) {
        return sources.map((source) => this.adapt(source));
    }
}
